export default __webpack_public_path__ + "static/media/2-sgi-home-v2.19cd86a0.png";